import axios from "axios"
import { API_BASE_URL } from "./services.config"

export class LastMovementService {
  constructor() {
    const baseUrl = API_BASE_URL.main
    if (!baseUrl) {
      console.log('API base URL not defined for main API')
    }
    this.url = baseUrl.endsWith("/") ? baseUrl : baseUrl + "/"
  }

  async getByEquipmentId(equipmentId) {
    const result = await axios
      .get(this.url + "LastMovement/byequipment/" + equipmentId)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        return error
      })
    return result
  }

  async getById(movementId) {
    const fullUrl = this.url + "LastMovement/" + movementId
    console.log('LastMovementService.getById - URL:', fullUrl)
    try {
      const response = await axios.get(fullUrl)
      console.log('LastMovementService.getById - Response status:', response.status)
      console.log('LastMovementService.getById - Response data type:', typeof response.data)
      console.log('LastMovementService.getById - Response data:', response.data)
      if (!response.data) {
        console.error('LastMovementService.getById - ERROR: Empty response data')
        return null
      }
      return response.data
    } catch (error) {
      console.error('LastMovementService.getById - ERROR:', error.message)
      if (error.response) {
        console.error('LastMovementService.getById - Error status:', error.response.status)
        console.error('LastMovementService.getById - Error data:', error.response.data)
      }
      return error
    }
  }
}
